import classNames from 'classnames/bind';
import React, { useState } from 'react';
import styles from './Help.module.scss';
import HelpButton from './HelpButton';
import HelpForm from './HelpForm';
import useFetchUserPermissions from '../../hooks/permissions/useFetchUserPermissions';

const cx = classNames.bind(styles);

const Help = (): React.ReactElement | null => {
  const [showForm, setShowForm] = useState(false);
  const { data: userPermissions } = useFetchUserPermissions();

  const toggleForm = () => {
    setShowForm((v) => !v);
  };

  return userPermissions?.hasAccessToGetHelp() ? (
    <div className={classNames(cx('body'), 'to-translate')}>
      {showForm && <HelpForm onClose={toggleForm} />}
      {!showForm && <HelpButton onClick={toggleForm} />}
    </div>
  ) : null;
};

export default Help;
